/*
  kyarna-global-atc.js
  Silent Add to Cart EVERYWHERE — product cards (home/collection/search)
  AND the main product page form.

  - Adds the product to the cart in the background via /cart/add.js
  - Always preventDefault()s the form submit, so the browser NEVER navigates
    to /cart or reloads the page, regardless of theme settings.
  - Customer stays on the same page, sees a quick "Added" confirmation.
  - Cart badge / icon updates everywhere immediately.
*/
(function () {
  'use strict';

  function updateBadges(count) {
    document.querySelectorAll('.cart-count-bubble').forEach(function (el) {
      el.removeAttribute('hidden');
      var s = el.querySelector('span[aria-hidden]');
      if (s) s.textContent = count;
    });
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
    });
    ['kmb-cart-badge', 'kynav-cart-badge'].forEach(function (id) {
      var el = document.getElementById(id);
      if (!el) return;
      el.textContent = count;
      count > 0 ? el.classList.add('on') : el.classList.remove('on');
    });
  }

  function refreshCartIconBubble() {
    fetch('/?sections=cart-icon-bubble', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (s) {
        if (!s['cart-icon-bubble']) return;
        var doc = new DOMParser().parseFromString(s['cart-icon-bubble'], 'text/html');
        var nb = doc.querySelector('.cart-count-bubble');
        var ob = document.querySelector('.cart-count-bubble');
        if (nb && ob) {
          ob.innerHTML = nb.innerHTML;
          ob.removeAttribute('hidden');
        }
      })
      .catch(function () {});
  }

  function setBtnLoading(btn, isLoading) {
    if (!btn) return;
    btn.disabled = isLoading;
    btn.classList.toggle('kyarna-atc--loading', isLoading);
  }

  function flashAdded(btn) {
    if (!btn) return;
    btn.classList.add('kyarna-atc--added');
    var label = btn.querySelector('span') || btn;
    var prevText = label.textContent;
    label.textContent = '✓ Added';
    setTimeout(function () {
      label.textContent = prevText;
      btn.classList.remove('kyarna-atc--added');
    }, 1600);
  }

  function afterSuccessfulAdd() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateBadges(cart.item_count);
        refreshCartIconBubble();
        document.dispatchEvent(
          new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: cart,
              sourceId: 'kyarna-global-atc',
              data: { itemCount: cart.item_count, source: 'kyarna-global-atc' },
            },
          })
        );
      })
      .catch(function () {});
  }

  /* ───────────────────────────────────────
     1) Intercept ALL add-to-cart-form submits, everywhere.
     Capture phase = runs before the theme's own handlers,
     so preventDefault() here always wins and the browser
     never navigates to /cart.
  ─────────────────────────────────────── */
  function handleFormSubmit(event) {
    var form = event.target;
    if (!form || !(form instanceof HTMLFormElement)) return;
    if (form.getAttribute('data-type') !== 'add-to-cart-form') return;

    event.preventDefault();
    event.stopImmediatePropagation();

    if (!form.checkValidity()) return;

    var submitBtn = form.querySelector('[ref="addToCartButton"], button[type="submit"], button[name="add"]');
    setBtnLoading(submitBtn, true);

    var formData = new FormData(form);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: formData,
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        setBtnLoading(submitBtn, false);
        if (data.status) {
          var errorBox = form.querySelector('[ref="addToCartTextError"]');
          if (errorBox) {
            errorBox.classList.remove('hidden');
            var textNode = errorBox.childNodes[2];
            if (textNode) textNode.textContent = data.message;
          }
          return;
        }
        flashAdded(submitBtn);
        return afterSuccessfulAdd();
      })
      .catch(function () {
        setBtnLoading(submitBtn, false);
      });
  }

  document.addEventListener('submit', handleFormSubmit, true);

  /* ───────────────────────────────────────
     1b) Buttons with data-kyarna-atc (used by the custom
     Kyarna collection grid section, kyarna-collection-max).
     These are plain <button type="button">, not inside a form.
  ─────────────────────────────────────── */
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-kyarna-atc]');
    if (!btn) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    if (btn.disabled) return;

    var variantId = btn.getAttribute('data-variant-id');
    var productUrl = btn.getAttribute('data-product-url');
    if (!variantId) {
      if (productUrl) window.location.href = productUrl;
      return;
    }

    setBtnLoading(btn, true);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 }),
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        setBtnLoading(btn, false);
        if (data.status) {
          if (productUrl) window.location.href = productUrl;
          return;
        }
        flashAdded(btn);
        return afterSuccessfulAdd();
      })
      .catch(function () {
        setBtnLoading(btn, false);
      });
  }, true);

  /* ───────────────────────────────────────
     2) Injected "Add to Cart" buttons on product cards
     (home page / collection / search grids) that don't
     have their own <form> — built dynamically per card.
  ─────────────────────────────────────── */
  function getVariantId(card) {
    var id = card.dataset.variantId || card.dataset.firstVariantId;
    if (id) return id;
    var inp = card.querySelector('input[name="id"]');
    if (inp) return inp.value;
    return null;
  }

  function injectCard(card) {
    if (card.dataset.kyarnaAtcDone) return;

    // If the card already renders a real add-to-cart-form (buy-buttons block),
    // we already intercept its submit above — no need to inject a duplicate button.
    if (card.querySelector('form[data-type="add-to-cart-form"]')) {
      card.dataset.kyarnaAtcDone = '1';
      return;
    }

    card.dataset.kyarnaAtcDone = '1';

    var variantId = getVariantId(card);
    var available = card.dataset.available !== 'false';
    var aLink = card.querySelector('a.product-card__link, a[href*="/products/"]');
    var productUrl = aLink ? aLink.href : null;

    if (!variantId || !available) return; // nothing safe to inject

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'kyarna-card-atc-btn';
    btn.innerHTML = '<span>Add to Cart</span>';
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      setBtnLoading(btn, true);
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 }),
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          setBtnLoading(btn, false);
          if (data.status) {
            if (productUrl) window.location.href = productUrl;
            return;
          }
          flashAdded(btn);
          return afterSuccessfulAdd();
        })
        .catch(function () {
          setBtnLoading(btn, false);
        });
    });

    var container = card.querySelector('.product-card__content') || card;
    container.appendChild(btn);
  }

  function scanCards() {
    document.querySelectorAll('product-card, .product-card').forEach(injectCard);
  }

  var mo = new MutationObserver(function (mutations) {
    var needsScan = false;
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes.length) {
        needsScan = true;
        break;
      }
    }
    if (needsScan) scanCards();
  });
  mo.observe(document.body, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scanCards);
  } else {
    scanCards();
  }
  document.addEventListener('shopify:section:load', scanCards);
})();
